import { createContext } from 'react';

export interface ToastPushOptions {
  description?: string;
  actionLabel?: string;
  onClick?: () => void;
  /** Explicit acknowledgement for legacy error notices; ordinary TTL is unchanged. */
  persistent?: boolean;
  onDismiss?: () => void;
}

export interface ToastItem {
  id: number;
  msg: string;
  description?: string;
  type?: 'info' | 'success' | 'warning' | 'danger' | 'error';
  ttl?: number;
  actionLabel?: string;
  onClick?: () => void;
  persistent?: boolean;
  onDismiss?: () => void;
}

export interface ToastCtx {
  push: (msg: string, type?: ToastItem['type'], ttl?: number, options?: ToastPushOptions) => void | (() => void);
}

export const ToastContext = createContext<ToastCtx>({ push:()=>{} });
